export const types = {
    RUN: 'RUN',
    OPEN: 'OPEN'
};